module.exports = __webpack_public_path__ + "static/img/mycompass_loginbkg_mnt2.3acf7ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mycompass_loginbkg_mnt2.jpg
// module id = cIdz
// module chunks = 0